<script>
import {axios, swal} from '../../mixins';

export default {
  name: 'GeoUpload',

  mixins: [axios, swal],

  props: {
    uploadUrl: {
      required: true,
      type: String,
    },
  },

  data() {
    return {
      file: '',
    };
  },

  methods: {
    /**
     * Open File explorer.
     */
    triggerUploadFileExplorer() {
      this.$refs.file.click();
    },

    /**
     * Upload received file to upload route, broadcasts route return
     */
    doUpload(event) {
      let files = event.target.files;
      if (!(files.length === 1)) {
        return;
      }

      let data = new FormData();
      data.append('_token', this.csrf());
      data.append('upload', event.target.files[0]);

      this.swalLoading('', 'Uploading file...');

      this.post(this.uploadUrl, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response) => {
        this.$emit('updateGeography', {
          'geography': response.data.content,
          'type': 'geo-upload',
        });

        this.swalClose();
        this.swalSuccess('', `Successfully uploaded file.`);
      }).catch(() => {
        this.$refs.file.value = '';
        this.swalClose();
        this.swalError('', `Failed to upload file. Please ensure file type is one of .shp, .kml, or .kmz and data is valid.`);
      });
    },
  },
};

</script>

<template>
  <div>
    <button type="button" @click="triggerUploadFileExplorer" name="button"
            class="ml-2 px-4 py-2 rounded text-white inline-block shadow-lg bg-blue hover:bg-blue-dark focus:bg-blue-darker">
      <i class="fad fa-upload"></i>
      <span class="pl-2">File</span>
    </button>
    <input type="file" ref="file" @change="doUpload" hidden>
  </div>
</template>
